import { render } from "./AddType.vue?vue&type=template&id=3953b4fe&ts=true"
import script from "./AddType.vue?vue&type=script&lang=ts"
export * from "./AddType.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__